<template>
  <div>
    <div class="mycontainer" style="margin-bottom: 0px">
      <el-form :inline="true">
        <el-form-item label="课题属性" label-width="80px">
          <el-select
            v-model="courseGroup"
            placeholder="全部"
            clearable
            filterable
            size="small"
            style="width: 150px"
            class="filter-item"
          >
            <el-option label="研究课题" value="1"></el-option>
            <el-option label="技术课题" value="2"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="年份" label-width="50px">
          <el-date-picker
            v-model="year"
            type="year"
            size="mini"
            format="yyyy"
            placeholder="选择年"
            value-format="yyyy"
            :picker-options="pickerOptions"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="课题名称" prop="name" label-width="80px">
          <el-input
            v-model="courseName"
            size="small"
            style="width: 150px"
            clearable
          ></el-input>
        </el-form-item>
        <span style="margin-top: 4px; display: inline-block">
          <el-button
            type="primary"
            icon="el-icon-search"
            size="small"
            @click="getList()"
            >查询</el-button
          >
          <el-button
            icon="el-icon-download"
            size="small"
            type="warning"
            @click="handleExport()"
            style="margin-left: 15px"
            >导出</el-button
          >
        </span>
      </el-form>
    </div>
    <div>
      <el-table
        :data="allTrackResult"
        fit
        :header-cell-style="tableHeaderColor"
        :default-sort="{ prop: 'date', order: 'descending' }"
        tooltip-effect="dark"
        :max-height="height"
      >
        <el-table-column
          label="课题编号"
          align="center"
          prop="courseid"
          sortable
          min-width="150px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="课题组长"
          align="center"
          prop="courseleadername"
          min-width="150px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="组员"
          align="center"
          prop="membername"
          min-width="150px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="课题名称"
          align="center"
          prop="coursename"
          min-width="150px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="课题属性"
          align="center"
          prop="coursegroup"
          min-width="150px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="拟结项时间"
          align="center"
          prop="closingitemapplytime"
          min-width="150px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="风险预警等级"
          align="center"
          sortable
          prop="risk_warning"
          min-width="150px"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span :class="scope.row.risk_warning | statusFilter">{{
              scope.row.risk_warning | formatStata
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="问题及意见"
          align="center"
          min-width="120px"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="detailed(scope.row.advice, '问题及意见详细')"
              >{{
                scope.row.advice == null ? "-" : scope.row.advice
              }}</el-button
            >
          </template>
        </el-table-column>
        <el-table-column
          label="处理人"
          align="center"
          prop="solveby"
          min-width="150px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="处理时间"
          align="center"
          prop="solvetime"
          sortable
          min-width="150px"
          :show-overflow-tooltip="true"
        />
        <template slot="empty">
          <div class="nodata">
            <img src="@/img/nodata.png" alt="" width="160" />
            <div>暂无数据</div>
          </div>
        </template>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[5, 10, 15, 20]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
      <el-dialog
        :visible.sync="detailOpen"
        :title="detailTitle"
        width="750px"
        :modal-append-to-body="false"
        append-to-body
      >
        <el-input
          v-model="detail"
          style="width: 700px"
          type="textarea"
          :rows="15"
          :readonly="true"
        />
      </el-dialog>
    </div>
  </div>
</template>
  
  <script>
import { allTrackResult, exportTrackResult } from "@/api/trackMonth.js";
export default {
  data() {
    return {
      page: 1,
      pageSize: 10,
      total: 0,
      courseGroup: "",
      year: new Date().getFullYear().toString(),
      courseName: "",
      allTrackResult: [{}],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      detail: "",
      detailOpen: false,
      detailTitle: "",
      height: 100,
    };
  },
  filters: {
    // el-tag类型转换
    statusFilter(status) {
      const statusMap = {
        1: "red_area",
        2: "yellow",
        3: "green",
        null: "",
      };
      return statusMap[status];
    },
    // 状态显示转换
    formatStata(status) {
      const statusMap = {
        1: "高风险",
        2: "中风险",
        3: "低风险",
        null: "-",
      };
      return statusMap[status];
    },
  },
  created() {
    if (this.$route.params.courseGroup) {
      this.courseGroup = this.$route.params.courseGroup + "";
    }
    this.getList();
  },
  methods: {
    getList() {
      allTrackResult(
        this.courseGroup,
        this.year,
        this.courseName,
        this.page,
        this.pageSize
      ).then((res) => {
        if (res.code == 0) {
          this.allTrackResult = res.data;
          this.total = res.count;
          const docH = document.documentElement.clientHeight;
          const mycontainerH =
            document.querySelector(".mycontainer").clientHeight;
          this.height = docH - mycontainerH - 135;
        }
      });
    },
    detailed(detial, detailTitle) {
      this.detailOpen = true;
      this.detailTitle = detailTitle;
      this.detail = detial;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f2f2f2;";
      }
    },
    handleExport() {
      exportTrackResult(this.courseGroup, this.year, this.courseName).then(
        (res) => {
          if (res.code === 0) {
            const fileName = res.msg.substr(
              res.msg.indexOf("_") + 1,
              res.msg.length
            );
            const filePath = res.msg;
            const url =
              window.g.apiUrl +
              "system/downloadFile?fileName=" +
              fileName +
              "&filePath=" +
              filePath;
            // 组装a标签
            const elink = document.createElement("a");
            // 设置下载文件名
            elink.download = fileName;
            elink.style.display = "none";
            elink.href = url;
            document.body.appendChild(elink);
            elink.click();
            document.body.removeChild(elink);
          } else {
            this.$message({
              showClose: true,
              message: res.msg,
              type: "error",
            });
          }
        }
      );
    },
  },
};
</script>
  
  <style>
.mycontainer {
  padding: 10px;
  background-color: #fff;
  border-radius: 6px;
}
.red_area {
  color: #fff;
  height: 28px;
  background-color: #ff0000;
  text-align: center;
  font-size: 12px;
  padding: 2px 15px;
  line-height: 28px;
  border-radius: 3px;
}
.yellow {
  color: #999;
  height: 28px;
  background-color: #ffff80;
  text-align: center;
  font-size: 12px;
  padding: 2px 15px;
  line-height: 28px;
  border-radius: 3px;
}
.green {
  color: #fff;
  height: 28px;
  background-color: #4b7902;
  text-align: center;
  font-size: 12px;
  padding: 2px 15px;
  line-height: 28px;
  border-radius: 3px;
}
</style>